export default "__VITE_ASSET__CyLyGfQM__"